<template>
  <div class="m-auto max-w-2xl" role="status">
    <p class="mb-6 text-center font-Playfair text-2xl" data-testid="thankyou">Thank you!</p>
    <div class="mx-auto mb-6 flex w-full flex-col items-center justify-center gap-y-4 bg-beige1 px-4 py-8">
      <p class="text-center font-Spectral text-base tracking-normal text-black2">We will email you as soon as new dates open up.<br />Reservations are first-come, first-served.</p>
      <!-- 登録の有無を読み取られないよう、購読の規則として述べる。条件文にすると初回登録のゲストに届かない -->
      <p class="text-center font-Spectral text-base tracking-normal text-black2">
        We keep one set of preferred dates per experience.<br />Your new dates replace any dates you previously submitted.
      </p>
    </div>
    <!-- 同一内容の再登録や配信抑制中のメアドには確認メールが送られないため、送信を断定しない -->
    <p class="text-center font-Spectral text-sm tracking-normal text-black2">
      If this is a new or updated subscription, you will receive a confirmation email shortly.<br />If you do not see it, please check your spam folder.
    </p>
  </div>
</template>
